<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div>
      <h1>{{ $t("blog.header") }}</h1>
      <div class="divide-y-2 divide-white py-18">
        <BlogHeaderSection
          v-if="blogLists"
          :data="headerBlog"
        ></BlogHeaderSection>
      </div>

      <BlogPosts :displayCategory="true"> </BlogPosts>
    </div>
  </div>
</template>

<script setup>
import { useGlobalStore } from "@/stores/global";
const globalStore = useGlobalStore();
defineI18nRoute({
  locales: ["en", "es"],
});
const headerBlog = ref({});

const {
  data: blogLists,
  pending,
  error: errorMessage,
  refresh,
} = await useBlogLatest();
headerBlog.value = blogLists.value.data;

const breadcrumbs = getBreadcrumbs("blog");
</script>
